import { ReactNode, useState } from 'react';

import { AuthenticatedUserProfile } from 'src/types/AuthenticatedUserProfile';

import { defaultRcnUserState, RcnUserContext } from './RcnUserContext';

type RcnUserProviderProps = {
	children: ReactNode;
};

export function RcnUserProvider(props: RcnUserProviderProps): JSX.Element {
	const [authenticatedUserProfile, setAuthenticatedUserProfile] = useState<AuthenticatedUserProfile | undefined>(
		defaultRcnUserState.authenticatedUserProfile
	);

	function updateAuthenticatedUserProfile(profile: AuthenticatedUserProfile | undefined) {
		setAuthenticatedUserProfile(profile);
	}

	const [userFavourites, setUserFavourites] = useState<string[] | undefined>(defaultRcnUserState.userFavourites);

	function updateUserFavourites(favourites: string[] | undefined) {
		setUserFavourites(favourites);
	}

	return (
		<RcnUserContext.Provider
			value={{
				authenticatedUserProfile: authenticatedUserProfile,
				updateAuthenticatedUserProfile: updateAuthenticatedUserProfile,
				userFavourites: userFavourites,
				updateUserFavourites: updateUserFavourites,
			}}
		>
			{props.children}
		</RcnUserContext.Provider>
	);
}
